const POLICY_LINK_SELECTOR = '#shopify-pc__banner__body-policy-link';
const INTERNATIONAL_STOREFRONT_HOSTS = new Set([
  'primegadget.uk',
  'www.primegadget.uk',
  'primegadget.fr',
  'www.primegadget.fr',
  'primegadgetshop.de',
  'www.primegadgetshop.de',
]);

function localizeCookiePolicyLink() {
  if (!INTERNATIONAL_STOREFRONT_HOSTS.has(window.location.hostname.toLowerCase())) return false;

  const policyLink = document.querySelector(POLICY_LINK_SELECTOR);
  if (!(policyLink instanceof HTMLAnchorElement)) return false;

  const expectedUrl = new URL('/policies/privacy-policy', window.location.origin).href;
  if (policyLink.href !== expectedUrl) policyLink.href = expectedUrl;
  return true;
}

function initializeCookiePolicyLink() {
  if (localizeCookiePolicyLink()) return;

  const observer = new MutationObserver(() => {
    if (!localizeCookiePolicyLink()) return;
    observer.disconnect();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 15000);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeCookiePolicyLink, { once: true });
} else {
  initializeCookiePolicyLink();
}
